import List from 'src/componentes/list/';
import ListColumn from 'src/componentes/list/list-column';
import Search from './Search';
import SearchSchema from './SearchSchema';
import { capitalizeFirstLetter } from 'src/utils/string';
import StatusBadge from 'src/componentes/StatusBadge';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import { FILTROS } from 'src/utils/constants';
import ContentManager from 'src/componentes/content-manager';
import Edit from './DocumentoEdit';
import { Folder } from 'lucide-react';

const DocumentoList = ({ ...rest }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const handleEdit = (item) =>
    ContentManager.addContent(
      <Edit item={item} isDocument={!item.agrupador} />
    );

  const renderNome = (item) => (
    <a
      className="font-weight-bold text-primary cursor-pointer"
      onClick={() => handleEdit(item)}
    >
      {item.agrupador && <Folder className="p-0 m-0" size={16} />} {item.nome}
    </a>
  );

  const renderStatus = (item) => {
    if (item?.status)
      return (
        <StatusBadge
          text={item.status.nome}
          textColor={item?.status?.corFundo ? item?.status?.cor : undefined}
          backgroundColor={item?.status?.corFundo || item?.status?.cor}
        />
      );
  };

  return (
    <List
      url="/Documento"
      showSearch={true}
      searchComponent={<Search />}
      searchSchema={SearchSchema}
      pageSize={10}
      showMenu={false}
      showNew={false}
      showExport={false}
      filtroId={FILTROS.DOCUMENTO}
      showPage={true}
      showModal={true}
      modalClose={true}
      {...rest}
    >
      <ListColumn
        tree={true}
        headerText={capitalizeFirstLetter(intl.formatMessage({ id: 'nome' }))}
        valueField="nome"
        valueFunction={renderNome}
        sortField="descricao"
        minWidth={150}
        default
      />
      <ListColumn
        headerText={capitalizeFirstLetter(
          intl.formatMessage({ id: 'labelTipoDocumento' })
        )}
        valueField="tipoDocumento"
        minWidth={150}
        default
      />
      <ListColumn
        headerText={capitalizeFirstLetter(resources.responsaveis)}
        valueField="responsaveis"
        minWidth={150}
        default
      />
      <ListColumn
        headerText={capitalizeFirstLetter(
          intl.formatMessage({ id: 'area' }, { area: resources.area })
        )}
        valueField="area"
        minWidth={150}
        default
      />
      <ListColumn
        headerText={capitalizeFirstLetter(
          intl.formatMessage({ id: 'dataVigencia' })
        )}
        valueField="dataVigencia"
        default
      />
      <ListColumn
        headerText={capitalizeFirstLetter(intl.formatMessage({ id: 'status' }))}
        valueField="status"
        valueFunction={renderStatus}
        default
      />
    </List>
  );
};

export default DocumentoList;